import { render, staticRenderFns } from "./IndividualContractor.vue?vue&type=template&id=2ca2475f&scoped=true&"
import script from "./IndividualContractor.vue?vue&type=script&lang=ts&"
export * from "./IndividualContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2475f",
  null
  
)

export default component.exports